export const backendUrl = process.env.REACT_APP_BACKEND_URL
export const vivekaUrl = process.env.REACT_APP_VIVEKA_URL
